module.exports = __webpack_public_path__ + "img/icon_heart_4.c7247278.svg";